import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

import { Pagination } from './pagination.types'
import { Error } from './error.types'

interface DiagnosticHypothesisData  {
  id: number
  cid_code: string
  description: string
}

interface ListDiagnosticHypothesesData {
  diagnostic_hypotheses: DiagnosticHypothesisData[]
  pagination: Pagination
}

interface DiagnosticHypothesis {
  id: number
  cidCode: string
  description: string
}

interface ListDiagnosticHypothesesResponse {
  diagnosticHypotheses: DiagnosticHypothesis[]
  pagination: Pagination
}

export const listDiagnosticHypotheses = (query?: string, page?: number): Promise<ListDiagnosticHypothesesResponse> => {
  const endpoint = apiEndpoints.MEDICAL_RECORDS_DIAGNOSTIC_HYPOTHESES

  const params = {
    per_page: 10,
    ...(query && { query }),
    ...(page && { page }),
  }

  return new Promise<ListDiagnosticHypothesesResponse> ((resolve, reject) => {
    axios.get<ListDiagnosticHypothesesData>(endpoint, { params })
      .then(response => {
        const diagnosticHypotheses = response.data.diagnostic_hypotheses.map(hypothesis => {
          return {
            id: hypothesis.id,
            description: hypothesis.description,
            cidCode: hypothesis.cid_code,
          } as DiagnosticHypothesis
        })

        const pagination = response.data.pagination

        resolve({
          diagnosticHypotheses,
          pagination,
        })
      })
      .catch((error: Error) => 
        reject(error?.response?.status)
      )
  })
}